import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TemplateSelectionComponent } from './components/template-selection/template-selection.component';
import { TemplateFormComponent } from './components/template-form/template-form.component';
import { ShareInterviewLinkComponent } from './components/share-interview-link/share-interview-link.component';

const routes: Routes = [
  { path: '', component: TemplateSelectionComponent },
  { path: 'form/:id', component: TemplateFormComponent },
  { path: 'share-interview/:id', component: ShareInterviewLinkComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TemplatesRoutingModule { }
